<template>
  <div class="diagnosis">
    <diagnosis-draft
    v-if="!preliminary.id || !preliminary.published_at"
     :value="value"
     :item-id="preliminary.id"
     :type="'preliminary'"
     ></diagnosis-draft>
    <diagnosis-published v-else :value="value" :item-id="preliminary.id" :type="preliminary.type"></diagnosis-published>

    <diagnosis-draft
    v-if="preliminary.published_at && (!final.id || !final.published_at)"
     :value="value"
     :item-id="final.id"
     type="final"
     ></diagnosis-draft>
    <diagnosis-published v-if="final.published_at" :value="value" :item-id="final.id" type="final"></diagnosis-published>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import DiagnosisDraft from '@/components/Cases/Diagnosis/Draft'
import DiagnosisPublished from '@/components/Cases/Diagnosis/Published'
export default {
  components: {
    DiagnosisDraft,
    DiagnosisPublished
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      preliminaryDiagnosis: 'pcase/preliminaryDiagnosis',
      finalDiagnosis: 'pcase/finalDiagnosis',
      caseById: 'pcase/byId'
    }),
    preliminary () {
      return (this.preliminaryDiagnosis(this.value) && this.preliminaryDiagnosis(this.value).length > 0 ? this.preliminaryDiagnosis(this.value)[0] : {})
    },
    final () {
      return (this.finalDiagnosis(this.value) && this.finalDiagnosis(this.value).length > 0 ? this.finalDiagnosis(this.value)[0] : {})
    }
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setInfermedica: 'infermedica/set',
      resetInfermedica: 'infermedica/reset'
    })
  }
}
</script>
<style lang="scss">
.diagnosis {
  .probable-conditions {
    .probable-condition {
      z-index: 11;
      position: relative;
      .badge {
        width: 35px;
      }
    }
    .progress-bar {
      height: 100%;
      position: absolute;
      left: 0;
      background-color: #3c88ff55;
      top: 0;
      z-index: 10;
    }
  }
  .disease-list {
    max-height: 400px;
    overflow: auto;
  }
  .create-btn {
    color: #fff;
  }
  .list-item {
    display: block;
    // border-top: 1px solid #ccc;
    color: #555;
    text-decoration: none;
    svg {
      transition: all 0.2s;
      width: 24px;
      height: 24px;
    }
    .case-open {
      transform: rotate(180deg);
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "diagnosis": "დიაგნოზი",
      "createPrediagnosis": "წინასწარი დიაგნოზის შექმნა",
      "createDiagnosis": "საბოლოო დიაგნოზი",
      "preliminary": "წინასწარი დიაგნოზი",
      "final": "საბოლოო დიაგნოზი",
      "condition": "დაავადება",
      "conditions": "დაავადებები",
      "comment": "დასკვნა",
      "save": "დამატება",
      "publish": "გამოქვეყნება",
      "delete": "წაშლა",
      "search": "ძიება",
      "addDisease": "დაავადების დამატება",
      "name": "დასახელება"
  },
  "en": {
      "diagnosis": "Diagnosis",
      "createPrediagnosis": "Create Preliminary Diagnosis",
      "createDiagnosis": "Create Diagnosis",
      "preliminary": "Preliminary Diagnosis",
      "final": "Final Diagnosis",
      "condition": "Condition",
      "conditions": "Conditions",
      "comment": "Comment",
      "save": "Save",
      "publish": "Publish",
      "delete": "Delete",
      "search": "Search",
      "addDisease": "Add Condition",
      "name": "Name"
  }
}
</i18n>
